export function getPosition() {
    const sel = window.getSelection();
    if (!sel) {
        return;
    }

    const sentinel = {
        right: -1,
        top: -1,
    };

    if (sel.rangeCount) {
        const range = sel.getRangeAt(0);
        const rects = range.getClientRects();

        if (rects.length === 0) {
            return sentinel;
        }

        let right = Number.MIN_VALUE;
        for (let i = 0; i < rects.length; i += 1) {
            const rect = rects[i];
            right = Math.max(right, rect.right);
        }

        return {
            right: right,
            top: rects[0].top,
        };
    }

    return sentinel;
}
